/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Google_SectionInputs */

const en_settings_google_section = /** @type {(inputs: Settings_Google_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Account`)
};

const he_settings_google_section = /** @type {(inputs: Settings_Google_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`חשבון גוגל`)
};

/**
* | output |
* | --- |
* | "Google Account" |
*
* @param {Settings_Google_SectionInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const settings_google_section = /** @type {((inputs?: Settings_Google_SectionInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Google_SectionInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_google_section(inputs)
	return he_settings_google_section(inputs)
});